import payload_plugin_qLmFnukI99 from "/home/manohar/dev/mall-nuxt/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import payload_plugin_ALLXFGgbCP from "/home/manohar/dev/mall-nuxt/node_modules/nuxt-vuefire/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/home/manohar/dev/mall-nuxt/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/manohar/dev/mall-nuxt/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/manohar/dev/mall-nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/manohar/dev/mall-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tiPVWYbfGV from "/home/manohar/dev/mall-nuxt/node_modules/@productdevbook/chatwoot/dist/runtime/plugin.js";
import siteConfig_JRId4KOeUL from "/home/manohar/dev/mall-nuxt/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/siteConfig.js";
import inferSeoMetaPlugin_JSh5nGhzCz from "/home/manohar/dev/mall-nuxt/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/inferSeoMetaPlugin.js";
import titles_eoILE7jqvj from "/home/manohar/dev/mall-nuxt/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/titles.js";
import plugin_tMGwffvjBc from "/home/manohar/dev/mall-nuxt/node_modules/@formkit/auto-animate/nuxt/runtime/plugin.mjs";
import plugin_client_pNVVgm7Ud2 from "/home/manohar/dev/mall-nuxt/node_modules/nuxt-vuefire/dist/runtime/app/plugin.client.js";
import vuefire_auth_plugin_client_cCwkwh1j5u from "/home/manohar/dev/mall-nuxt/.nuxt/vuefire-auth-plugin.client.mjs";
import vuefire_plugin_8cq4FnzXKb from "/home/manohar/dev/mall-nuxt/.nuxt/vuefire-plugin.mjs";
import plugin_PSbK9A48ZQ from "/home/manohar/dev/mall-nuxt/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import slideovers_X7whXyrIWR from "/home/manohar/dev/mall-nuxt/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/home/manohar/dev/mall-nuxt/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/home/manohar/dev/mall-nuxt/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/home/manohar/dev/mall-nuxt/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/home/manohar/dev/mall-nuxt/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import Vue3Lottie_client_bMZiOS6AB0 from "/home/manohar/dev/mall-nuxt/plugins/Vue3Lottie.client.ts";
import analytics_client_mtqVw3YRXk from "/home/manohar/dev/mall-nuxt/plugins/analytics.client.ts";
import api_GFfDXud5Cr from "/home/manohar/dev/mall-nuxt/plugins/api.ts";
import auth_client_4lHQFpoKNF from "/home/manohar/dev/mall-nuxt/plugins/auth.client.ts";
import defaults_M8ptihKv0z from "/home/manohar/dev/mall-nuxt/node_modules/nuxt-seo-utils/dist/runtime/app/plugins/defaults.js";
export default [
  payload_plugin_qLmFnukI99,
  payload_plugin_ALLXFGgbCP,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tiPVWYbfGV,
  siteConfig_JRId4KOeUL,
  inferSeoMetaPlugin_JSh5nGhzCz,
  titles_eoILE7jqvj,
  plugin_tMGwffvjBc,
  plugin_client_pNVVgm7Ud2,
  vuefire_auth_plugin_client_cCwkwh1j5u,
  vuefire_plugin_8cq4FnzXKb,
  plugin_PSbK9A48ZQ,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  Vue3Lottie_client_bMZiOS6AB0,
  analytics_client_mtqVw3YRXk,
  api_GFfDXud5Cr,
  auth_client_4lHQFpoKNF,
  defaults_M8ptihKv0z
]